import Arrow from '../UI/arrow/Arrow'
import Circle from '../UI/circle/Circle'
import Factory from "../../assets/image/Factory.svg"
import Connection from "../../assets/image/Connection.svg"
import MonitoringSoftware from "../../assets/image/Monitoring-Software.svg"

export default function Begining() {
    return (
        <div id="Begining" className='pt-[80px]'>
            <h3 className='w-full h-[36px] text-[36px] leading-[100%] text-[#100F10] font-Poppins font-normal text-center mb-5 lg:h-[64px] lg:text-[64px]'>As <span className='font-bold'> Simple </span> as that!</h3>
            <div className='flex justify-around min-h-[300px] sm:px-20 md:px-48 lg:flex-col lg:px-36 xl:px-48'>
                <div className='flex flex-row-reverse justify-between lg:flex-col lg:w-[100%]'>
                    <div className=' flex flex-col justify-between lg:m-3 lg:flex-row'>
                        <img src={Factory} alt="Factory" className='w-[70px] h-[70px] lg:w-[159px] lg:h-[159px]' />
                        <img src={Connection} alt="Connection" className='w-[70px] h-[70px] lg:w-[159px] lg:h-[159px]' />
                        <img src={MonitoringSoftware} alt="MonitoringSoftware" className='w-[70px] h-[70px] lg:w-[159px] lg:h-[159px]' />
                    </div>

                    <div className=' flex flex-col justify-between items-center mr-5 my-4 lg:flex-row lg:mx-16'>
                        <Circle />
                        <Arrow />
                        <Circle />
                        <Arrow />
                        <Circle />
                    </div>
                </div>

                <div className='flex flex-col justify-between lg:flex-row'>
                    <span className='w-[175px] h-[23px] font-Poppins font-bold text-[18px] text-primary leading-[125%] text-left lg:text-center  pt-5 lg:pt-0'>Your Factory </span>
                    <span className='w-[175px] h-[46px] font-Poppins font-bold text-[18px] text-[#F9A83D] leading-[125%] text-left lg:text-center pt-5 lg:pt-0'>Connect it to our hardware</span>
                    <span className='w-[175px] h-[77px] font-Poppins font-bold text-[18px] text-[#6EBA6E] leading-[125%] text-left lg:text-center'>24/7 Monitoring on a Cross platform Software</span>
                </div>
            </div>
        </div>
    )
}